import { Button, Card, Col, Image, Row, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import AvailabiltyIconSvg from "assets/availability.svg";
import AvailableIconSvg from "assets/available.svg";
import NotAvailableIconSvg from "assets/not-available.svg";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import CheckMarkSvg from "assets/check.svg";
import classNames from "classnames";
import { ENUMERATOR_STATUS } from "enum/enumerator-status";
import { useLocation, useNavigate } from "react-router-dom";
import { useUpdateEnumeratorAvailability } from "api/enumerator/Availability/useUpdateAvailabilityStatus";
import AvailabilityForm from "./components/AvailabilityForm";
import { storage } from "utils/storage";
// import ErrorPage from "components/ui/ErrorPage";

const { Title, Text } = Typography;

const Availibility = () => {
  const [status, setStatus] = React.useState<ENUMERATOR_STATUS>();
  const [queryValue, setQueryValue] = React.useState<string | null>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false)


  const updateStatusMutation = useUpdateEnumeratorAvailability();
  const user = storage.getUserFromStorage();

  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const statusValue = queryParams.get("status");
    setQueryValue(statusValue);
  }, [location.search]);

  const handleUnavailable = () => {
    setLoading(true)
    const payload: any = {
      isAvailable: false,
      uid: user?.uid,
    };

    updateStatusMutation.mutate(payload, {
      onSettled: () => {setLoading(false)},
      onSuccess: () => {
        navigate("/enumerator/home");
      },
    });
  };

  return (
    <>
      
      <div className="bg-background  px-5 md:px-5">
      <>
        {loading && (
          <div className="absolute w- full inset-0 flex items-center justify-center bg-white bg-opacity-60 z-50">
            <Spin size="large" />
          </div>
        )}
      
        
      </>
        <div className="max-w-6xl mx-auto py-12">
          <Card className="px-0 md:px-8 py-2">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <Title level={2} style={{ fontWeight: 700 }}>
                Employability/Availability
              </Title>
              <img alt="#" src={AvailabiltyIconSvg} />
            </div>
          </Card>
          {queryValue === ENUMERATOR_STATUS.AVAILABLE ? (
          
           
          
            <AvailabilityForm /> 
          ) : (
            <Card className="px-0 md:px-8 py-2 mt-8">
              <Row gutter={[24, 24]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Card
                    className={classNames(
                      "bg-background",
                      "hover:outline-none",
                      "hover:ring-1",
                      " hover:ring-primary",
                      " hover:border-transparent",
                      " hover:bg-secondary",
                      "cursor-pointer",
                      "position-relative",
                      { "bg-secondary": status === ENUMERATOR_STATUS.AVAILABLE },
                      { "outline-none": status === ENUMERATOR_STATUS.AVAILABLE },
                      { "ring-1": status === ENUMERATOR_STATUS.AVAILABLE },
                      { "ring-primary": status === ENUMERATOR_STATUS.AVAILABLE },
                      { "border-transparent": status === ENUMERATOR_STATUS.AVAILABLE }
                    )}
                    onClick={() => setStatus(ENUMERATOR_STATUS.AVAILABLE)}
                  >
                    <Row gutter={[32, 24]}>
                      <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <Image src={AvailableIconSvg} width={42} preview={false} />
                      </Col>
                      <Col xs={24} sm={24} md={21} lg={21} xl={21}>
                        <Title level={3}>I am available</Title>
                        <Text style={{ fontSize: "16px", color: "#6B7280", lineHeight: "24px" }}>
                          Passionate about finding the perfect match between exceptional talent and
                          career-defining opportunities.
                        </Text>
                      </Col>
                    </Row>
                    {status === ENUMERATOR_STATUS.AVAILABLE && (
                      <div
                        className="absolute h-7 w-7 bg-green-600 -top-1 -left-1 rounded-full flex justify-center items-center"
                      >
                        <img alt="#" src={CheckMarkSvg} />
                      </div>
                    )}
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Card
                    className={classNames(
                      "bg-background",
                      "hover:outline-none",
                      "hover:ring-1",
                      " hover:ring-primary",
                      " hover:border-transparent",
                      " hover:bg-secondary",
                      "cursor-pointer",
                      "position-relative",
                      { "bg-secondary": status === ENUMERATOR_STATUS.NOT_AVAILABLE },
                      { "outline-none": status === ENUMERATOR_STATUS.NOT_AVAILABLE },
                      { "ring-1": status === ENUMERATOR_STATUS.NOT_AVAILABLE },
                      { "ring-primary": status === ENUMERATOR_STATUS.NOT_AVAILABLE },
                      { "border-transparent": status === ENUMERATOR_STATUS.NOT_AVAILABLE }
                    )}
                    onClick={() => setStatus(ENUMERATOR_STATUS.NOT_AVAILABLE)}
                  >
                    <Row gutter={[32, 32]}>
                      <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <Image src={NotAvailableIconSvg} width={42} preview={false} />
                      </Col>
                      <Col xs={24} sm={24} md={21} lg={21} xl={21}>
                        <Title level={3}>I am currently unavailable</Title>
                        <Text style={{ fontSize: "16px", color: "#6B7280", lineHeight: "24px" }}>
                          Strategically sculpting my career trajectory for the success – where
                          ambition meets the accomplishment.
                        </Text>
                      </Col>
                    </Row>
                    {status === ENUMERATOR_STATUS.NOT_AVAILABLE && (
                      <div
                        className="absolute h-7 w-7 bg-green-600 -top-1 -left-1 rounded-full flex justify-center items-center"
                      >
                        <img alt="#" src={CheckMarkSvg} />
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>

              <div className="flex flex-col md:flex-row gap-y-4 justify-between  pt-12">
                <Button
                  className="h-12 px-8 border border-1 border-border text-base font-bold flex items-center justify-center gap-2"
                  onClick={() => navigate("/enumerator/home")}
                >
                  <ArrowLeftOutlined />
                  Back Home
                </Button>
                <Button
                  className="h-12 px-8 border-2 border-border text-base font-bold flex items-center justify-center gap-2 bg-primary text-white border-none"
                  onClick={() => {
                    if (status === ENUMERATOR_STATUS.NOT_AVAILABLE) {
                      handleUnavailable();
                    }

                    if (status === ENUMERATOR_STATUS.AVAILABLE)
                      navigate("/enumerator/availibility/?status=available");
                  }}
                  type="primary"
                // loading={updateStatusMutation.isPending}
                >
                  Continue
                  <ArrowRightOutlined />
                </Button>
              </div>
            </Card>
          )}

        </div>
      </div>
    </>
  );
};

export default Availibility;